import React from "react"
import { DatoContentBaseProps } from "../../types"
import FeaturedSlider from "@components/FeaturedSlider"

interface DatoCmsComponentFeaturedSliderProps extends DatoContentBaseProps {}

const stripHash = (value?: string) =>
  value?.startsWith("#") ? value.slice(1) : value

const formatProduct = (item: any = {}) => ({
  id: item?.id,
  productImage: item?.productImage?.responsiveImage,
  productImageSrc: item?.productImage?.url,
  productTitle: item?.productTitle,
  subtext: item?.subtext,
  productTitleColor: stripHash(item?.productTitleColor?.hex),
  subtextColor: stripHash(item?.subtextColor?.hex),
  buttonText: item?.buttonText,
  buttonTextColor: stripHash(item?.buttonTextColor?.hex),
  buttonColor: stripHash(item?.buttonColor?.hex),
  buttonLink: item?.buttonLink,
})

const DatoCmsComponentFeaturedSlider: React.FC<
  DatoCmsComponentFeaturedSliderProps
> = ({
  sectionTitle,
  sectionTitleColor,
  backgroundColor,
  backgroundImage,
  featuredProducts,
}) => {
  return (
    <FeaturedSlider
      sectionTitle={sectionTitle}
      sectionTitleColor={stripHash(sectionTitleColor?.hex)}
      backgroundColor={stripHash(backgroundColor?.hex)}
      backgroundImageSrc={
        backgroundImage?.responsiveImage?.src || backgroundImage?.url
      }
      featuredProducts={(featuredProducts || []).map(formatProduct)}
    />
  )
}

export default DatoCmsComponentFeaturedSlider
